import { apiClient } from "@wtf/shared/api/utils/api-client";
import { ProductDto, CreateProductRequest, UpdateProductRequest, ScrapedProductDto } from "@wtf/shared";

const BASE_ENDPOINT = "api/products";

/**
 * Create a new product
 * Products are automatically positioned at the end of the look or collection
 */
export async function createProduct(data: CreateProductRequest): Promise<ProductDto> {
  return apiClient<ProductDto>(BASE_ENDPOINT, "POST", data);
}

/**
 * Get a product by ID
 */
export async function getProductById(id: string): Promise<ProductDto> {
  return apiClient<ProductDto>(`${BASE_ENDPOINT}/${id}`);
}

/**
 * Update a product
 */
export async function updateProduct(id: string, data: UpdateProductRequest): Promise<ProductDto> {
  return apiClient<ProductDto>(`${BASE_ENDPOINT}/${id}`, "PUT", data);
}

/**
 * Like a product
 */
export async function likeProduct(id: string): Promise<void> {
  return apiClient<void>(`${BASE_ENDPOINT}/${id}/like`, "POST");
}

/**
 * Unlike a product
 */
export async function unlikeProduct(id: string): Promise<void> {
  return apiClient<void>(`${BASE_ENDPOINT}/${id}/like`, "DELETE");
}

/**
 * Scrape product details from a URL before creation
 */
export async function scrapeProduct(url: string): Promise<ScrapedProductDto> {
  return apiClient<ScrapedProductDto>(`${BASE_ENDPOINT}/scrape`, "POST", { url });
}

export const productsApi = {
  createProduct,
  getProductById,
  updateProduct,
  likeProduct,
  unlikeProduct,
  scrapeProduct,
};
